import theme from '../../../../../lib/theme';
import { TravelHolidayBlockProps } from './TravelHolidayBlock';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  container: {
    ...layouts.column,
    alignItems: 'center',
    padding: `0 ${scale.xs} 0`,
  },
});